import {
  LOADING_ARRAY,
  LIST_UNIT_AUTOMATIONS_REQUEST, LIST_UNIT_AUTOMATIONS_RESPONSE,
  ADD_UNIT_AUTOMATION_RESPONSE,
  REMOVE_UNIT_AUTOMATION_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// unitId -> [automationIds, ...]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_UNIT_AUTOMATIONS_REQUEST:
      return {
        ...state,
        [action.unitId]: state[action.unitId] || LOADING_ARRAY,
      }
    case LIST_UNIT_AUTOMATIONS_RESPONSE:
      return {
        ...state,
        [action.unitId]: (action.automations || []).map((d) => d.id),
      }
    case ADD_UNIT_AUTOMATION_RESPONSE:
      return {
        ...state,
        [action.unitId]: [...state[action.unitId], action.automation.id],
      }
    case REMOVE_UNIT_AUTOMATION_RESPONSE:
      return {
        ...state,
        [action.unitId]: state[action.unitId].filter((id) => id !== action.automationId),
      }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
